import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    signin : [],
    loading : false,
    error : null,
};

const signinSlice = createSlice({
    name:"signin",
    initialState,
    reducers: {
        fetchsigninSuccess: (state,action) => {
            state.loading = false;
            state.signin = action.payload
        },
        fetchsigninFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    }
})

export const {
    fetchsigninFailure,
    fetchsigninSuccess
} = signinSlice.actions

export default signinSlice.reducer